import { render, staticRenderFns } from "./IntentionMajor.vue?vue&type=template&id=251be447&scoped=true"
import script from "./IntentionMajor.vue?vue&type=script&lang=js"
export * from "./IntentionMajor.vue?vue&type=script&lang=js"
import style0 from "./IntentionMajor.vue?vue&type=style&index=0&id=251be447&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251be447",
  null
  
)

export default component.exports